import { render, staticRenderFns } from "./AmountButtons.vue?vue&type=template&id=7a21b097&"
import script from "./AmountButtons.vue?vue&type=script&lang=js&"
export * from "./AmountButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports